export default __webpack_public_path__ + "static/media/something-went-wrong.365f4445.svg";